import { Helmet } from "react-helmet-async";

/**
 * 페이지별 SEO 메타태그 컴포넌트
 * @param {{ title: string, description: string, keywords: string, url: string }} meta - seo-meta.js의 항목
 */
const PageHelmet = ({ meta }) => {
  if (!meta) return null;
  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <link rel="canonical" href={meta.url} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={meta.url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://by-law.kr/thumbnail.jpg" />
      <meta property="og:site_name" content="법대리" />
      <meta property="og:locale" content="ko_KR" />
    </Helmet>
  );
};

export default PageHelmet;
